import { fetchApi } from '../api/collectionManager';
import { getFileMetadata } from '../api/digitalVault';
import { parseCollection, parseFiles } from '../utils/parser';
import { fetchCache, getCacheKey, persistCache, parseCollectionsPagination, validateCache, } from '../utils';
const getUserCollectionById = async (params = {}, collectionId, lcid, collectionCacheProps, logger) => {
    if (collectionCacheProps?.enableCache) {
        const key = getCacheKey({
            params,
            endpoint: `${collectionCacheProps?.cacheKeyPrefix}-${lcid}/collections/${collectionId}`,
        });
        const cacheResp = await fetchCache('user_collections', key);
        if (cacheResp) {
            const { hasNextPage, nextPageParams } = parseCollectionsPagination(cacheResp.data.links);
            return {
                data: cacheResp.parsedFiles,
                isDataFromCache: true,
                updateCache: false,
                hasNextPage,
                collectionName: cacheResp.data.name,
                mediaItemsCount: cacheResp.data.mediaItemsCount,
                collectionId: cacheResp.data.id,
                creationDate: cacheResp.data.creationDate,
                source: cacheResp.data.source,
                type: cacheResp.data.type,
                clientAttributes: cacheResp.data.clientAttributes,
                paginate() {
                    return (hasNextPage &&
                        getUserCollectionById(nextPageParams, collectionId, lcid, collectionCacheProps, logger));
                },
            };
        }
    }
    return await userCollectionByIdApi(params, collectionId, lcid, collectionCacheProps, logger);
};
const userCollectionByIdApi = async (params, collectionId, lcid, collectionCacheProps, logger) => {
    let collection = await fetchApi(params, `collections/${collectionId}`, logger);
    let updateCache = false;
    if (collection?.collectionItems) {
        const { hasNextPage, nextPageParams } = parseCollectionsPagination(collection.links);
        const collectionMetaData = await getFileMetadata(parseCollection(collection), logger);
        const data = parseFiles(collectionMetaData.files);
        const collectionItems = Array.isArray(collection.collectionItems)
            ? collection.collectionItems
            : [collection.collectionItems];
        const parsedFiles = data.map((file) => {
            let collectionPhotoId;
            collectionItems.forEach((value) => {
                if (value?.uri?.includes(`${file?.repository}:${file?.nodeId}`)) {
                    collectionPhotoId = value?.id;
                    return;
                }
            });
            return {
                collectionId: collection.id,
                collectionPhotoId,
                source: collection?.source,
                ...file,
            };
        });
        const orderedFiles = collectionItems
            .map((item) => {
            const [, , , nodeId] = item.uri.split(':');
            return parsedFiles.find((parsedFile) => parsedFile.nodeId === nodeId);
        })
            .filter((item) => item !== undefined && item !== null);
        const key = getCacheKey({
            params,
            endpoint: `${collectionCacheProps?.cacheKeyPrefix}-${lcid}/collections/${collectionId}`,
        });
        const value = { url: key, data: collection, parsedFiles: orderedFiles };
        if (collectionCacheProps?.validateCache) {
            const { dataUpdated } = await validateCache('user_collections', key, value);
            updateCache = dataUpdated;
        }
        if (collectionCacheProps?.enableCache || updateCache) {
            await persistCache('user_collections', key, value);
        }
        return {
            data: orderedFiles,
            isDataFromCache: false,
            updateCache,
            hasNextPage,
            collectionName: collection.name,
            mediaItemsCount: collection.mediaItemsCount,
            collectionId: collection.id,
            creationDate: collection.creationDate,
            source: collection.source,
            type: collection.type,
            clientAttributes: collection.clientAttributes,
            coverItem: collection.coverItem,
            paginate() {
                return (hasNextPage &&
                    getUserCollectionById(nextPageParams, collectionId, lcid, collectionCacheProps, logger));
            },
        };
    }
    return {
        hasNextPage: false,
        data: [],
        isDataFromCache: false,
        updateCache: false,
        paginate() {
            return null;
        },
    };
};
export default getUserCollectionById;
